import { Button, Modal, Tooltip } from 'antd';
import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { permissionNameIdMap } from 'hooks/business/useNewPermisson';
import useModal from 'hooks/useModal';
import { useEffect, useState } from 'react';
import { storeUsers } from 'services/api/admin';
import tfWechatImage from 'assets/channels/tfsoftware/wechat.png';
import { isTfsoftware } from 'productLine';
import { T, useTranslate } from '@tolgee/react';

export interface NonAssistLimitTipProps {
  conversation: Conversation.Conversation;
}

const userListRef = {
  current: [] as Assistant.Account[],
};

function NonAssistLimitTip(props: NonAssistLimitTipProps) {
  const { conversation } = props;

  const { t } = useTranslate();

  const [, forceUpdate] = useState(false);

  useEffect(() => {
    if (userListRef.current.length > 0) {
      return;
    }

    const { storeId } = conversation;

    storeUsers({
      storeId,
      permId: permissionNameIdMap.帐号管理,
    })
      .then((userList) => {
        userListRef.current = userList;
        forceUpdate((_) => !_);
      })
      .catch(() => {});
  }, [conversation]);

  const { current: userList } = userListRef;

  const { visible, show, hide } = useModal();

  const { contactQrcode } = useFlagConfigValue();

  const modal = (
    <Modal
      title={t('header.联系我们')}
      width={260}
      footer={false}
      visible={visible}
      onCancel={hide}
    >
      <img
        src={isTfsoftware ? tfWechatImage : contactQrcode}
        alt={t('header.联系我们')}
        width="100%"
      />
    </Modal>
  );

  return (
    <>
      <div>{t('account.当前帐号为接待限额帐号，本月可接待买家数已达上限')}</div>
      {userList.length > 0 && (
        <T
          keyName="account.请联系x升级为接待不限额帐号或联系我们"
          params={{
            x: <UserList userList={userList} />,
            y: <Button type="link" onClick={show} />,
          }}
        />
      )}
      {modal}
    </>
  );
}

const displayUserListLimit = 3;

function UserList(props: { userList: Assistant.Account[] }) {
  const { userList } = props;

  const userListRender = (userList: Assistant.Account[]) => {
    return userList.map(({ name, account }) => `[${name || account}]`).join(' ');
  };

  const displayUserList = <span>{userListRender(userList.slice(0, displayUserListLimit))}</span>;

  const ellipsisUserList = userList.length > displayUserListLimit && (
    <Tooltip title={userListRender(userList.slice(displayUserListLimit))}>
      <span style={{ marginLeft: '4px', cursor: 'pointer' }}>...</span>
    </Tooltip>
  );

  return (
    <>
      {displayUserList}
      {ellipsisUserList}
    </>
  );
}

export default NonAssistLimitTip;
